<template>
  <div class="border-b-2 border-grey-200 py-6">
    <Container use-full-width>
      <div class="flex items-start justify-between gap-10">
        <!-- FILTER CATEGORY DESKTOP -->
        <AnimatedContainer :stagger="0.05">
          <ul class="flex flex-wrap gap-x-12 gap-y-3 self-stretch pt-2 max-lg:hidden">
            <li v-for="locationType in locationTypes" :key="locationType?.id" class="slide-left">
              <button
                :class="{ 'text-primary-900': filter?.locationType === locationType?.slug }"
                class="font-semibold transition-colors typo-subtitle"
                type="button"
                @click="onFilterLocationType(locationType?.slug || '')"
              >
                {{ locationType?.title }}
              </button>
            </li>
          </ul>
        </AnimatedContainer>

        <!-- FILTER CATEGORY MOBILE -->
        <SingleSelect
          title="locations-filter"
          :model-value="locationTypes.find((locationType) => locationType?.slug === filter?.locationType) || undefined"
          placeholder="auswählen"
          class="mt-0.5 pt-2 lg:hidden"
          :options="locationTypes || []"
          @update:model-value=" filter ? filter.locationType = $event.slug : null"
        />
        <div class="flex items-center gap-x-6">
          <Transition name="fade">
            <div v-if="loading">
              <IconSpin class="ml-4 size-8 animate-spin text-primary-900" />
            </div>
          </Transition>
          <!-- OPEN CLOSE SEARCH-COLLAPSE -->
          <AppButton class="shrink-0" @click="isSearchCollapseOpen = !isSearchCollapseOpen">
            <template #icon>
              <Transition tag="div" name="fade" mode="out-in">
                <IconClose v-if="isSearchCollapseOpen" class="size-7" />
                <IconFilter v-else class="size-7" />
              </Transition>
            </template>
          </AppButton>
        </div>
      </div>
    </Container>
  </div>
  <div ref="searchCollapse" class="shadow-md" :class="{ 'h-0 overflow-hidden': !isMounted }">
    <Container use-full-width class="flex gap-y-8 py-14 gap-x-default max-lg:flex-col">
      <div class="flex-1 lg:max-w-144">
        <label class="mb-1.5 block text-grey-300 typo-subtitle" for="location-search">{{ $t('find_location') }}</label>
        <SearchInput
          id="location-search"
          :value="filter ? filter.searchLocation : ''"
          :placeholder="$t('enter_location')"
          @input="filter ? filter.searchLocation = $event : ''"
        >
          <template #icon>
            <IconLocationMarker class="size-6" />
          </template>
        </SearchInput>
      </div>
      <div class="flex-1 lg:max-w-144">
        <label class="mb-1.5 block text-grey-300 typo-subtitle" for="contact-person-search">{{ $t('find_contact_person') }}</label>
        <SearchInput
          id="contact-person-search"
          :value="filter ? filter.searchTeamMember : ''"
          :placeholder="$t('enter_name')"
          @input="filter ? filter.searchTeamMember = $event : ''"
        />
      </div>
    </Container>
  </div>
</template>

<script setup lang="ts">
import type { LocationFilterType } from '~/components/main-components/LocationsFinder.vue'

withDefaults(
  defineProps<{
    locationTypes: Array<{
      id: string
      slug: string
      title: string
    }>
    loading: boolean
  }>(),
  {
    locationTypes: () => [],
  },
)
const filter = defineModel<LocationFilterType>()

// Collapse Search
const searchCollapse = ref<HTMLElement | undefined>(undefined)
const isSearchCollapseOpen = useCollapse(searchCollapse, {
  duration: 300,
  initiallyClosed: false,
})

function onFilterLocationType(slug: string) {
  if (!filter.value) {
    return
  }
  if (filter.value.locationType === slug) {
    filter.value.locationType = 'all'

    return
  }
  filter.value.locationType = slug
}

const isMounted = ref<boolean>(false)
onMounted(() => {
  // To hide the collapse before it is mounted (workaround) when it should be collapsed initially
  isMounted.value = true
})
</script>
